import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + '/api/aut';

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, { username, password });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error('Terjadi kesalahan saat login');
    }
  }
};

export const resetPassword = (payload) => {
  return axios.post(`${BASE_URL}/reset`, payload);
};